export default "__VITE_PUBLIC_ASSET__84646346__"